import { useEffect, useRef, useState } from 'react';
import { Marquee } from '../../../components';
import { useLang, type Lang } from '../../../i18n';
import { get } from '../../../services/api';
import useIntersectionFadeIn from '../../../hooks/useIntersectionFadeIn';

interface Partner { id: string | number; name: string; logo?: string; url?: string }
interface PartnersApi { items?: Partner[]; results?: Partner[] }

const LANG_MAP: Record<Lang, string> = { 'uz-Latn': 'uz_lat', 'uz-Cyrl': 'uz_cyr', ru: 'ru', en: 'en' };

export default function PartnersSection() {
  const { t, lang } = useLang();
  const [items, setItems] = useState<Partner[]>([]);
  const rootRef = useRef<HTMLElement>(null);
  const visible = useIntersectionFadeIn(rootRef);

  useEffect(() => {
    let cancel = false;
    (async () => {
      try {
        const res = await get<PartnersApi>(`/partners/?lang=${LANG_MAP[lang]}`);
        if (cancel) return;
        setItems(res?.items || res?.results || []);
      } catch {
        if (!cancel) setItems([]);
      }
    })();
    return () => { cancel = true; };
  }, [lang]);

  if (!items.length) return null;

  return (
    <section ref={rootRef} className={`section partners scroll-fade-in${visible ? ' scroll-fade-in--visible' : ''}`}>
      <div className="container">
        <header className="section-header">
          <span className="eyebrow">{t('home.partners.eyebrow')}</span>
          <h2>{t('home.partners.title')}</h2>
        </header>
      </div>
      <Marquee pauseOnHover duration={48}>
        {items.map((p) => (
          <div key={p.id} className="partners__item" title={p.name}>
            {p.logo ? (
              <img src={p.logo} alt={p.name} loading="lazy" />
            ) : (
              <span className="partners__name">{p.name}</span>
            )}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
